export const CORE_EXCHANGE_ITEM_SELECT_GRID_CODE = 'warehouse-core-exchange-item-select';
